import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
  row: {
    borderBottom: (p) => (p.disabled ? 'none' : `2px solid ${theme.palette.divider}`),
    padding: theme.spacing(1),
    position: 'relative',
    width: 'calc(100% - 16px)',

    '&:hover': {
      cursor: (p) => (p.disabled ? 'default' : 'pointer'),
      backgroundColor: (p) => (p.disabled ? 'transparent' : theme.palette.action.disabledBackground),
      pointerEvents: (p) => (p.disabled ? 'none' : undefined),
    },

    '& .firstRow': {
      marginBottom: theme.spacing(0.5),
    },

    '& .secondRow': {
      marginLeft: (p) => (p.isMobile ? 0 : 8),
      marginTop: (p) => (p.isMobile ? theme.spacing(3) : 0),
    },

    '& .col': {
      width: (p) => (p.isMobile ? '33%' : '20%'),
    },

    '& .progBar': {
      width: (p) => (p.isMobile ? 'auto' : '20%'),
      left: 'auto',
      position: (p) => (p.isMobile ? 'relative' : 'absolute'),
      right: (p) => (p.isMobile ? 0 : 8),
      top: (p) => (p.isMobile ? 0 : 30),
    },
  },
}));
